export default __webpack_public_path__ + "static/media/0281.dbe2e8f3.jpg";